import { ComponentType } from 'react'
import { AllCardsType } from '../../../data/all-cards'
import PhotoCards10 from '../../../components/photo-cards/photo-cards-10'
import { getComboCardLayout } from '../../combos/shared/combo-card-layouts'
import PhotoCards1 from '../../consultas/pregunta/photo-cards'
import PhotoCards3 from '../../consultas/tres-preguntas/photo-cards'
import PhotoCards4 from '../../consultas/cuatro-preguntas/photo-cards'
import PhotoCards5 from '../../consultas/cinco-preguntas/photo-cards'
import PhotoCardsSino from '../../consultas/sino/photo-cards'
import PhotoCardsMejor from '../../consultas/mejor/photo-cards'
import PhotoCardsVidaPasada from '../../consultas/vida-pasada/photo-cards'

type PhotoProps = { cards: AllCardsType[]; mazo: string; tapiz: string }

const PhotoMejorAdapter = ({ cards }: PhotoProps) => <PhotoCardsMejor cards={cards} />

/** Tiradas / pasos de combo que usan la grilla compartida de 10 cartas. */
const PHOTO_10_TYPES = new Set([
    'amor',
    'celta',
    '2-preguntas',
    'abundancia',
    'trabajo',
    'infidelidad',
    'futuro',
    'atraccion',
    'autoconocimiento',
    'yo-futuro',
    'temporada',
    'interior',
    'bloqueo',
    'propio',
    'encrucijada',
    'guias',
    'romper',
    // combos fijos (pasos de 10)
    'combo-renacer-temporada',
    'combo-renacer-interior',
    'combo-renacer-yo-futuro',
    'combo-abundancia-prosperidad',
    'combo-abundancia-bloqueo',
    'combo-abundancia-yo-futuro',
    'combo-amor-solteros',
    'combo-amor-propio',
    'combo-amor-yo-futuro',
    'combo-claridad-encrucijada',
    'combo-claridad-guias',
    'combo-claridad-temporada',
    'combo-proposito-temporada',
    'combo-proposito-yo-futuro',
    'combo-sanacion-interior',
    'combo-sanacion-romper',
    'combo-sanacion-guias',
])

/** Layouts propios (no son la grilla de 10). */
const PHOTO_SPECIAL: Record<string, ComponentType<PhotoProps>> = {
    pregunta: PhotoCards1,
    '3-preguntas': PhotoCards3,
    '4-preguntas': PhotoCards4,
    '5-preguntas': PhotoCards5,
    sino: PhotoCardsSino,
    vidapasada: PhotoCardsVidaPasada,
    mejor: PhotoMejorAdapter,
    'combo-proposito-renacer': getComboCardLayout('renacer').Photo,
}

/**
 * Resuelve el componente de foto para Mis consultas.
 * Cubre tiradas sueltas, combos fijos y combo-flexible-*.
 */
export const resolveConsultPhoto = (
    type: string | undefined,
    cardCount?: number
): ComponentType<PhotoProps> | null => {
    if (!type || type === 'compatibilidad') return null

    if (type.startsWith('combo-flexible-')) {
        const spreadId = type.slice('combo-flexible-'.length)
        return getComboCardLayout(spreadId, cardCount).Photo
    }

    if (PHOTO_SPECIAL[type]) return PHOTO_SPECIAL[type]

    if (PHOTO_10_TYPES.has(type)) return PhotoCards10

    // general, ex-pareja, proteccion, evolutivo, renacer
    if (
        type === 'general' ||
        type === 'ex-pareja' ||
        type === 'proteccion' ||
        type === 'evolutivo' ||
        type === 'renacer'
    ) {
        return getComboCardLayout(type, cardCount).Photo
    }

    // Último recurso: por cantidad de cartas
    return getComboCardLayout(undefined, cardCount).Photo
}
